/** Renders source links for a recommended thread. */
import React from 'react';

import type { Sources as SourcesType } from '@atlassian/conversation-assistant-service-api/types/assistance-service';
import type { ThreadSource } from '@atlassian/rovo-navigation/home-threads-service';

import { SourcesPopupTrigger } from '../../sources/SourcesPopupTrigger';

interface SourcesProps {
	sources: readonly ThreadSource[];
	testId?: string;
}

/** A click-triggered logo stack that shows a popup listing all source links for a thread. */
export const Sources = ({ sources, testId }: SourcesProps): React.JSX.Element | null => {
	const mappedSources: SourcesType = sources
		.filter(
			(source) =>
				source.__typename === 'ConvoAiHomeThreadsFirstPartySource' ||
				source.__typename === 'ConvoAiHomeThreadsThirdPartySource',
		)
		.map((source) => ({
			ari: source.__typename === 'ConvoAiHomeThreadsFirstPartySource' ? (source.ari ?? '') : '',
			title: '',
			type:
				source.__typename === 'ConvoAiHomeThreadsFirstPartySource' && source.data?.__typename
					? source.data.__typename
					: (source.__typename ?? ''),
			url: source.url ?? '',
			lastModified: '',
		}));

	if (mappedSources.length === 0) {
		return null;
	}

	return <SourcesPopupTrigger sources={mappedSources} testId={testId} />;
};
